import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import Zones from 'components/Admin/ZoneManagement/Zones';
// eslint-disable-next-line
export default function ZonesScreen(): JSX.Element {
  return (
    <ContentLayout>
      <SiteContent>
        <Zones />
      </SiteContent>
    </ContentLayout>
  );
}
